import { render, staticRenderFns } from "./AppBannerView.vue?vue&type=template&id=4222dcf6&scoped=true&"
import script from "./AppBannerView.vue?vue&type=script&lang=js&"
export * from "./AppBannerView.vue?vue&type=script&lang=js&"
import style0 from "./AppBannerView.vue?vue&type=style&index=0&id=4222dcf6&lang=scss&rel=stylesheet&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4222dcf6",
  null
  
)

export default component.exports